"use strict";

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _objectWithoutProperties(e, t) {
  var r = {};
  for (var o in e) t.indexOf(o) >= 0 || Object.prototype.hasOwnProperty.call(e, o) && (r[o] = e[o]);
  return r;
}
function Reveal(e) {
  function t(e) {
    return e ? _ ? {
      duration: n,
      delay: f,
      count: s,
      forever: d,
      className: _,
      style: {}
    } : y : i ? {
      duration: void 0 === o ? u : o,
      delay: p,
      count: a,
      forever: l,
      className: i,
      style: {}
    } : c;
  }
  var r = e.children,
    o = e.timeout,
    u = e.duration,
    p = e.delay,
    a = e.count,
    l = e.forever,
    n = e.durationOut,
    f = e.delayOut,
    s = e.countOut,
    d = e.foreverOut,
    i = e.effect,
    _ = e.effectOut,
    c = e.inEffect,
    y = e.outEffect,
    O = _objectWithoutProperties(e, ["children", "timeout", "duration", "delay", "count", "forever", "durationOut", "delayOut", "countOut", "foreverOut", "effect", "effectOut", "inEffect", "outEffect"]);
  return (0, _wrap2.default)(O, t(!1), t(!0), r);
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var _extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  },
  _propTypes = require("prop-types"),
  _globals = require("./globals"),
  _wrap = require("./wrap"),
  _wrap2 = _interopRequireDefault(_wrap),
  _Fade = require("./Fade"),
  _Fade2 = _interopRequireDefault(_Fade),
  propTypes = {
    in: _propTypes.object,
    out: (0, _propTypes.oneOfType)([_propTypes.object, (0, _propTypes.oneOf)([!1])]),
    effect: _propTypes.string,
    effectOut: _propTypes.string,
    duration: _propTypes.number,
    timeout: _propTypes.number,
    delay: _propTypes.number,
    count: _propTypes.number,
    forever: _propTypes.bool,
    durationOut: _propTypes.number,
    delayOut: _propTypes.number,
    countOut: _propTypes.number,
    foreverOut: _propTypes.bool
  },
  defaultProps = _extends({}, _globals.defaults, {
    durationOut: _globals.defaults.duration,
    delayOut: _globals.defaults.delay,
    countOut: _globals.defaults.count,
    foreverOut: _globals.defaults.forever,
    inEffect: (0, _Fade2.default)(_globals.defaults),
    outEffect: (0, _Fade2.default)(_extends({
      out: !0
    }, _globals.defaults))
  });
Reveal.propTypes = propTypes, Reveal.defaultProps = defaultProps, exports.default = Reveal, module.exports = exports.default;